import * as Icons from "heroicons-react";
import { useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import {
  resetSupplierSlice,
  supplierProducts,
  updateFieldValue,
} from "../../features/supplierSlice";
import SearchProduct from "../Common/CustomSelect/SearchProduct";
import Header from "../Common/Header/Header";
import SideBar from "../Common/SideBar/SideBar";
import "./Supplier.css";

import { useAddSupplierMutation } from "../../services/supplierApi";

import { notify } from "../Utility/Notify";
import { apiUniqueErrHandle } from "../Utility/Utility";
// import SupplierProductModal from "../Common/Modal/SupplierProductModal";
import axios from "axios";
import LoadingModal from "../Common/Modal/LoadingModal";
import { signInUser } from "../Utility/Auth";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

const CreateSupplier = () => {
  const supplierData = useSelector((state) => state.supplierReducer);

  const getCartData = supplierData.products;

  // console.log("supplierData:", supplierData)

  const auth = signInUser();
  const { aamarId } = auth;
  // console.log(aamarId)
  let i = 1;
  // const [pData, setPData] = useState([]);
  const [AddSupplier] = useAddSupplierMutation();
  const [supplierCode, setSupplierCode] = useState();
  const { register, handleSubmit, reset } = useForm({});
  const supplierProductsRef = useRef(null);

  const [loader, setLoader] = useState(false);
  const handleLoaderClose = () => setLoader(false);

  let navigate = useNavigate();
  const dispatch = useDispatch();

  // Uniq Code
  // CHECK UNIQUE
  const checkCodeInAPI = async (code) => {
    try {
      const response = await axios.get(
        `${BASE_URL}supplier/unique/${code}/${aamarId}`,
        {
          params: { code },
        }
      );
      console.log(response.data.exists);
      return response.data.exists;
    } catch (error) {
      console.error("Error checking code in API:", error);
      return false; // Default to not found in case of an error
    }
  };

  const supplierUniqueSixDigitCode = async () => {
    let numericCode;
    do {
      const uuid = uuidv4();
      numericCode = parseInt(uuid.split("-")[0], 16) % 1000000;
      numericCode = String(numericCode).padStart(6, "0");
    } while (await checkCodeInAPI(numericCode));

    setSupplierCode(numericCode);
    return numericCode;
  };

  useEffect(() => {
    supplierUniqueSixDigitCode();
  }, []);

  // ADD TO LIST
  const addToList = async (data) => {
    // console.log(data);
    if (data) {
      console.log("add to list:", data);
      await supplierProductsRef?.current?.blur();
      // const getData = JSON.parse(localStorage.getItem("supplier_cart"));
      let listData = getCartData ? getCartData : [];
      console.log("old:", listData);

      let newProduct = {};
      // unique check
      const idExist = listData.find((pro) => pro?.id === data?._id);
      console.log(idExist);
      if (idExist) {
        notify("Product Already in List", "error");
        // console.log()
      } else {
        newProduct = {
          id: data._id,
          name: data.name,
          article_code: data.article_code,
          ean: data.ean,
          unit: data.unit,
          aamarId: auth?.aamarId,
          warehouse: auth?.warehouse,
          order: listData.length + 1,
        };
        listData = [...listData, newProduct];
      }

      // console.log("upcoming:", newProduct);
      // console.log("Updated:", listData);
      // setPData(listData);
      dispatch(supplierProducts(listData));

      // console.log(newProduct)
      // localStorage.setItem("supplier_cart", JSON.stringify(listData));
      supplierProductsRef.current.focus();
    } else {
      return false;
    }
  };

  const handleFieldChange = (field, value) => {
    dispatch(updateFieldValue({ field, value }));
  };

  const onSubmit = async (data) => {
    const generatedCode = await supplierUniqueSixDigitCode();

    try {
      console.log("SupplierData", supplierData);
      const response = await AddSupplier({
        ...supplierData,
        code: generatedCode,
        aamarId,
      });
      if (response) {
        console.log(response);
        if (response?.error) {
          apiUniqueErrHandle(response);
        } else {
          reset({
            name: "",
            email: "",
            code: "",
            company: "",
            products: [],
            address: "",
            type: "",
            phone: "",
            status: "",
          });
          // console.log(data);
          dispatch(resetSupplierSlice());
          return navigate("/supplier");
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoader(false);
    }
  };
  const handleReset = () => {
    reset({
      name: supplierData.name,
      email: supplierData.email,
      code: supplierData.code,
      company: supplierData.company,
      type: supplierData.type,
      address: supplierData.address,
      phone: supplierData.phone,
      status: supplierData.status,
    });
  };

  const removeFromCart = (id) => {
    // const getData = JSON.parse(localStorage.getItem("supplier_cart"));
    const restData = getCartData.filter((pro) => pro.id !== id);
    // localStorage.setItem("supplier_cart", JSON.stringify(restData));
    dispatch(supplierProducts(restData));
    // setPData(restData);
    // console.log(restData);
  };

  useEffect(() => {
    handleReset();
  }, []);

  return (
    <div>
      <div className="container-fluid">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title={"Add Supplier"}></Header>
            <div className="row">
              <div className="col-md-12">
                <div className="">
                  <div className=" mt-1">
                    <div className="card-body">
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                          <div className="form-group col-4">
                            {/* <label htmlFor="inputSupplierCompany">Supplier Company</label> */}
                            <input
                              {...register("company", { required: true })}
                              type="text"
                              className="form-control "
                              id="inputSupplierCompany"
                              placeholder=" Company"
                              onChange={(e) =>
                                handleFieldChange("company", e.target.value)
                              }
                            />
                          </div>
                          <div className="form-group col-4  mb-3">
                            {/* <label htmlFor="inputSupplier">Supplier Name</label> */}
                            <input
                              {...register("name", { required: true })}
                              type="text"
                              className="form-control"
                              id="inputSupplier"
                              placeholder=" Name"
                              onChange={(e) =>
                                handleFieldChange("name", e.target.value)
                              }
                            />
                          </div>
                          <div className="form-group col-4  mb-3">
                            {/* <label htmlFor="inputEmail">Supplier Email</label> */}
                            <input
                              {...register("email", { required: true })}
                              type="email"
                              className="form-control"
                              id="inputEmail"
                              placeholder=" Email"
                              onChange={(e) =>
                                handleFieldChange("email", e.target.value)
                              }
                            />
                          </div>
                          <div className="form-group col-4  mb-3">
                            {/* <label htmlFor="inputMC">Supplier Phone</label> */}
                            <input
                              {...register("phone")}
                              type="text"
                              className="form-control"
                              id="phone"
                              placeholder=" Phone"
                              onChange={(e) =>
                                handleFieldChange("phone", e.target.value)
                              }
                            />
                          </div>
                          <div className="form-group col-4  mb-3">
                            {/* <label htmlFor="status">Status</label> */}
                            <input
                              {...register("code")}
                              type="text"
                              className="form-control"
                              id="code"
                              value={supplierCode}
                              readOnly
                              placeholder=" code"
                              onChange={(e) =>
                                handleFieldChange("code", e.target.value)
                              }
                            />
                          </div>
                          <div className="form-group col-4  mb-3">
                            {/* <label htmlFor="status">Status</label> */}
                            <select
                              {...register("status")}
                              className="form-select"
                              id="status"
                              onChange={(e) =>
                                handleFieldChange("status", e.target.value)
                              }
                            >
                              <option value="active">Active</option>
                              <option value="inactive">Inactive</option>
                            </select>
                          </div>
                          <div className="form-group col-12  mb-3">
                            {/* <label htmlFor="address">Address</label> */}
                            <textarea
                              {...register("address")}
                              className="form-control"
                              id="address"
                              placeholder="Address"
                              onClick={(e) =>
                                handleFieldChange("address", e.target.value)
                              }
                            />
                          </div>
                          {/* </div> */}
                          <div className="col-12 mb-3">
                            <p className="mb-1">
                              <b>Supplier's Products</b>
                            </p>
                            <SearchProduct
                              className="searchProduct"
                              // getValue={getValue}
                              addToList={addToList}
                              supplierProductsRef={supplierProductsRef}
                            ></SearchProduct>
                            {/* <ProductSearch
                            addToCart={addToCart}
                            searchResult={searchResult}
                            handleProductOnChange={handleProductOnChange}
                          /> */}
                          </div>
                          {/* <div className="col-2 mb-3 mt-4">
                            <button
                              className="btn btn-dark btn-block "
                              onClick={importProduct}
                            >
                              <Icons.Plus> </Icons.Plus>
                              Import Products
                            </button>
                          </div> */}

                          <div className="col-12 mb-3">
                            <div className="card mt-3 p-2">
                              <Table>
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>EAN</th>
                                    <th>Name</th>
                                    <th>Code</th>
                                    <th>Unit</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {getCartData ? (
                                    getCartData
                                      // ?.sort((a, b) => b?.order - a?.order)
                                      .map((item) => (
                                        <tr key={item.order}>
                                          <th>{i++}</th>
                                          <td>{item.ean}</td>
                                          <td>{item.name}</td>
                                          <td>{item.article_code}</td>
                                          {console.log("item::>>",item)}
                                          <td>{item?.unit}</td>
                                          <td>
                                            <Icons.X
                                              size={20}
                                              onClick={() =>
                                                removeFromCart(item.id)
                                              }
                                            ></Icons.X>
                                          </td>
                                        </tr>
                                      ))
                                  ) : (
                                    <tr>
                                      <td colSpan={6}>
                                        <p className="text-center m-2">
                                          Please select product
                                        </p>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </div>
                        </div>
                        <button
                          type="submit"
                          className="btn btn-dark float-end "
                        >
                          <Icons.Plus size={18} className="mx-2" />
                          Create Supplier
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline float-end mx-3"
                          onClick={() => dispatch(resetSupplierSlice())}
                        >
                          <Icons.X size={18} className="mx-2" />
                          Cancle
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toaster position="bottom-right" />
    </div>
  );
};

export default CreateSupplier;
